import { FontFamily } from '@euler/components/typography/fonts';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useMemo } from 'react';
import { StyleSheet } from 'react-native';

export const useWidgetStyles = () => {
  const { rpx } = useResponsiveContext();
  return useMemo(
    () =>
      StyleSheet.create({
        card: {
          backgroundColor: '#F8FAFC',
          borderRadius: rpx(10),
          padding: rpx(12),
          marginVertical: rpx(6),
          borderLeftWidth: rpx(3),
          borderLeftColor: '#E2E8F0',
        },
        row: {
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        },
        title: {
          fontSize: rpx(14),
          fontFamily: FontFamily.NotoSans.Bold,
          color: '#1E293B',
        },
        meta: {
          fontSize: rpx(12),
          fontFamily: FontFamily.NotoSans.Regular,
          color: '#64748B',
          marginTop: rpx(2),
        },
        statusBadge: {
          paddingHorizontal: rpx(8),
          paddingVertical: rpx(2),
          borderRadius: rpx(10),
        },
        statusText: {
          fontSize: rpx(11),
          fontFamily: FontFamily.NotoSans.Medium,
        },
        loading: {
          paddingVertical: rpx(12),
          alignItems: 'center',
        },
        loadingText: {
          fontSize: rpx(12),
          fontFamily: FontFamily.NotoSans.Regular,
          color: '#94A3B8',
        },
      }),
    [rpx],
  );
};
